<template>
  <div class="quick-answer-bar" @click="handleShowQueDetail" v-if="answer.showTip">
    <span>答题正在进行中...</span>
    <div @click.stop="handle2Detail" v-if="isAuth || hasQueAuth" class="icon-container">
      <i class="iconfont icon-setup"></i>
    </div>
  </div>
</template>

<script>
import {getAllExam, getExamAuth, getPaper} from '@/api'
export default {
  data() {
    return {
      id: this.$route.params.id,
      paperId: '',
      type: '',

      hasQueAuth: false
    }
  },
  computed: {
    isAuth() {
      return this.$store.getters.isAuth
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    answer() {
      return this.$store.state.activePlay.answer
    }
  },
  created() {
    this.initList()
    this.getQueAuth()
  },
  methods: {
    /* 维护活动管理员 */
    async getQueAuth() {
      const result = await getExamAuth(this.id)
      this.hasQueAuth = result.data
    },
    async handleShowQueDetail() {
      const params = {
        eventId: this.id,
        userId: this.userInfo.id
      }
      const result = await getPaper(params)

      if (result && result.data.status === 1) {
        return this.$Toast.fail('您已经答题了')
      }
      if (result) {
        this.$store.commit('setAnswerInfo', {
          showPanel: true
        })
      }
    },
    async initList() {
      const result = await getAllExam({eventId: this.id})
      const list = result.data || []
      if (result.code === 0) {
        const target = list.filter(item => item.status === 1)
        if (target && target.length > 0) {
          this.paperId = target[0].eventExamPaperId
          this.type = target[0].type
          this.$store.commit('setAnswerInfo', {
            showTip: true,
            objectType: target[0].type,
            objectId: target[0].eventExamPaperId
          })
        } else {
          this.$store.commit('setAnswerInfo', {
            showTip: false,
            objectType: '',
            objectId: ''
          })
        }
      }
    },
    handle2Detail() {
      if (this.paperId) {
        if (this.type === 1) {
          this.$router.push(`/activeQueDetail/${this.id}?paperId=${this.paperId}&status=1`)
        } else {
          this.$router.push(`/activeSimpleDetail/${this.id}?paperId=${this.paperId}&status=1`)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.quick-answer-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 60px;
  height: 44px;
  background: rgba(74, 134, 246, 0.9);
  color: #fff;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.icon-container {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  text-align: center;
  line-height: 22px;
  background: rgba(255, 255, 255, 0.5);
}
</style>
